import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LotSkuDetailContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/LotSkuDetail/LotSkuDetailContainer';

class invManLotSkuDetailView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <LotSkuDetailContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManLotSkuDetailView;
